import { XMarkIcon } from '@heroicons/react/24/outline'
import cx from 'classix'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import afiULogoFullWhiteEn from '@src/assets/svg/afiU-logo-horizontal-white-en.png'
import afiULogoFullWhiteFr from '@src/assets/svg/afiU-logo-horizontal-white-fr.svg'
import i18n from '@src/config/i18n'
import locales from '@src/config/locales'

import { getMainTabs, MainTab } from '../constants/mainTab'
import MobileMenuButton from './MobileMenuButton'
import MobileMenuContainer from './MobileMenuContainer'
import MobileMenuFooter from './MobileMenuFooter'
import AboutUsMobileTabMenu from './tabs/AboutUsMobileTabMenu'
import OrganizationsMobileTabMenu from './tabs/OrganizationsMobileTabMenu'
import ProgramsMobileTabMenu from './tabs/ProgramsMobileTabMenu'
import ResourcesMobileTabMenu from './tabs/ResourcesMobileTabMenu'
import TrainingsMobileTabMenu from './tabs/TrainingsMobileTabMenu'

type Props = {
  open: boolean
  close: () => void
}

export default function MobileMenuPopover({ open, close }: Props) {
  const { t } = useTranslation(`revamp`)
  const locale = i18n.language
  const [selectedTab, setSelectedTab] = useState<MainTab>()

  const afiULogo = locale === 'fr' ? afiULogoFullWhiteFr : afiULogoFullWhiteEn

  const mainTabs = getMainTabs(t)
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  const closeCurrentTab = () => {
    setSelectedTab(undefined)
  }

  function onClose() {
    closeCurrentTab()
    close()
  }

  return (
    <div
      className={cx(
        'overflow-hidden lg3:hidden fixed inset-0 w-full overflow-y-auto text-white  bg-revamp-red-600 transform transition-all duration-300',
        open ? 'opacity-100 z-10 pointer-events-auto' : 'opacity-0 pointer-events-none'
      )}
    >
      <div className='absolute top-0 inset-x-0 flex items-center h-20 p-5'>
        <a className='h-full w-full' href={locales[locale].homePath}>
          <img className='h-auto' src={afiULogo} alt='afiU logo' style={{ maxWidth: '204px' }} />
        </a>
        <button className='ml-4 flex-shrink-0' onClick={onClose}>
          <XMarkIcon className='rounded-full border border-white text-white h-5 w-5' />
        </button>
      </div>
      <MobileMenuContainer open={selectedTab === undefined} translateLeftHidden>
        <section className='flex flex-col gap-8 mt-14'>
          {mainTabs.map((tab) => (
            <MobileMenuButton
              key={`mobile_main_tab_${tab.name}`}
              title={t(tab.name)}
              onClick={() => setSelectedTab(tab.key)}
            />
          ))}
        </section>
      </MobileMenuContainer>
      <TrainingsMobileTabMenu open={selectedTab === MainTab.TRAININGS} onClose={closeCurrentTab} />
      <ProgramsMobileTabMenu open={selectedTab === MainTab.PROGRAMS} onClose={closeCurrentTab} />
      <OrganizationsMobileTabMenu
        open={selectedTab === MainTab.ORGANIZATIONS}
        onClose={closeCurrentTab}
      />
      <AboutUsMobileTabMenu open={selectedTab === MainTab.ABOUT} onClose={closeCurrentTab} />
      <ResourcesMobileTabMenu open={selectedTab === MainTab.RESOURCES} onClose={closeCurrentTab} />
      <MobileMenuFooter />
    </div>
  )
}
